import { useSearchParams } from 'next/navigation'
import {
  useFeatureFlagEnabled,
  useFeatureFlagPayload,
  useFeatureFlagVariantKey,
} from 'posthog-js/react'

const isDev = process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production'

const useIsFeatureOn = (feature: string, localOverride?: boolean | string) => {
  const searchParams = useSearchParams()
  const featureOn = useFeatureFlagEnabled(feature)
  const payload = (useFeatureFlagPayload(feature) || {}) as Record<string, any>
  const variant = useFeatureFlagVariantKey(feature)

  // Only consider query param override if it exactly matches the feature name
  const queryParamOverride =
    searchParams?.get('flag') === feature ? true : undefined

  // Only consider local override in dev if it's explicitly defined
  const devOverride =
    isDev && localOverride !== undefined ? localOverride : undefined

  const devOverrideVariant =
    devOverride && typeof devOverride === 'string' ? devOverride : undefined

  // Priority: query param > localOverride (in dev) > PostHog
  const override =
    queryParamOverride !== undefined ? queryParamOverride : devOverride
  const isReady = override !== undefined || featureOn !== undefined

  return {
    featureOn: override ?? featureOn,
    variant: devOverrideVariant ?? variant,
    payload,
    isReady,
    loading: !isReady,
  } as const
}

export default useIsFeatureOn
